var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting_content" }, [
    _c("div", { staticClass: "setting_content_main" }, [
      _c("div", { staticClass: "setting_content_heading" }, [
        _c("h2", { staticClass: "setting_content_title" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.customizeLabelsProperties.TAB_HEADER) +
              "\n      "
          )
        ]),
        _c(
          "div",
          { staticClass: "setting_content_heading_btn_holder" },
          [
            _vm.selectedTheme !== -1 && _vm.customizeSettings.length !== 0
              ? _c(
                  "button",
                  {
                    staticClass: "setting_btn_outline setting_btn_medium",
                    on: {
                      click: function($event) {
                        return _vm.openModalCustomizeScreen(1)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.customizeLabelsProperties.EDIT_THEME_BUTTON
                        ) +
                        "\n        "
                    )
                  ]
                )
              : _vm._e(),
            _c(
              "button",
              {
                staticClass: "setting_btn_secondary setting_btn_medium",
                on: {
                  click: function($event) {
                    return _vm.openModalCustomizeScreen(2)
                  }
                }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.customizeLabelsProperties.CREATE_THEME_BUTTON) +
                    "\n        "
                )
              ]
            ),
            _c("CustomizeScreenModal", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isVisibleModalCustomizeScreen,
                  expression: "isVisibleModalCustomizeScreen"
                }
              ],
              attrs: {
                categories: _vm.categories,
                colors: _vm.colors,
                privacy: _vm.privacy,
                message: _vm.message,
                button: _vm.button,
                masters: _vm.masters,
                entryPageName: _vm.entryPageName,
                entryOverview: _vm.entryOverview,
                draftColors: _vm.draftColors,
                isShowRemoveTheme: _vm.isThemeDefault,
                userId: _vm.log.info.userId,
                groupName: _vm.log.groupName,
                optionCustomizeColor: _vm.optionCustomizeColor
              },
              on: {
                updateCustomizeSettings: _vm.updateCustomizeColors,
                remove: function($event) {
                  return _vm.removeCustomizeTheme($event)
                },
                close: _vm.cancelUpdateCustomizeColors,
                setLoggerData: function($event) {
                  return _vm.setLoggerData($event)
                }
              }
            })
          ],
          1
        )
      ]),
      _c("p", { staticClass: "setting_content_explain" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.customizeLabelsProperties.FIRST_SUB_HEADER) +
            "\n      "
        ),
        _c("br"),
        _vm._v(
          "\n      " +
            _vm._s(_vm.customizeLabelsProperties.SECOND_SUB_HEADER) +
            "\n    "
        )
      ]),
      _c("form", { on: { change: _vm.logChangeData } }, [
        _c("div", { staticClass: "setting_theme" }, [
          _c(
            "ul",
            { staticClass: "setting_theme_list" },
            _vm._l(_vm.customizeSettings, function(customize, index) {
              return _c(
                "li",
                {
                  key: index,
                  staticClass: "setting_theme_item",
                  attrs: { id: index }
                },
                [
                  customize.id
                    ? _c(
                        "label",
                        {
                          staticClass:
                            "setting_theme_label setting_form_radio_label",
                          class: {
                            is_checked: _vm.selectedTheme === customize.id
                          }
                        },
                        [
                          _c("div", { staticClass: "setting_theme_box" }, [
                            _c("img", {
                              staticClass: "setting_theme_image",
                              attrs: {
                                width: "120",
                                height: "100",
                                alt:
                                  _vm.customizeLabelsProperties
                                    .ALTERNATIVE_DEFAULT_THEME_IMG +
                                  _vm.indexImgTheme(index),
                                src: require("@/assets/img/theme/img_theme" +
                                  _vm.indexImgTheme(index) +
                                  ".svg")
                              }
                            })
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.computedSelectedTheme,
                                expression: "computedSelectedTheme"
                              }
                            ],
                            attrs: { type: "radio" },
                            domProps: {
                              value: customize.id,
                              checked: _vm._q(
                                _vm.computedSelectedTheme,
                                customize.id
                              )
                            },
                            on: {
                              change: function($event) {
                                _vm.computedSelectedTheme = customize.id
                              }
                            }
                          }),
                          _c(
                            "span",
                            {
                              staticClass:
                                "setting_form_radio_text setting_word_break"
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(customize.themeName) +
                                  "\n              "
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ]
              )
            }),
            0
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }